export default class CareersLobby {
  constructor() {
    this.selector = '.b-careers-lobby';

    this.selectors = {
      pagination: '.b-careers-lobby__jobs-pagination',
      job: '.b-careers-lobby__job',
      jobs: '.b-careers-lobby__jobs',
      jobsWrap: '.b-careers-lobby__jobs-wrap',
      page: '.b-careers-lobby__jobs-page',
      paginationPrev: '.b-careers-lobby__jobs-pagination-item__prev',
      paginationNext: '.b-careers-lobby__jobs-pagination-item__next',
      paginationItem: '.b-careers-lobby__jobs-pagination-item',
      paginationPages: '.b-careers-lobby__jobs-pagination-pages',
    };

    this.classes = {
      active: 'active',
      disabled: 'disabled',
      dropdownOpen: 'dropdown-open',
    };
  }

  bootstrap() {
    this.wrappers = [ ...document.querySelectorAll(this.selector) ];

    if (this.wrappers.length === 0) {
      return;
    }

    this.wrappers.forEach(wrapper => {
      const allJobs = [ ...wrapper.querySelectorAll(this.selectors.job) ];

      this.pagination(wrapper);
      this.filters(wrapper, allJobs);
    });
  }

  filters(wrapper, allJobs) {
    const filters = [ ...wrapper.querySelectorAll('.b-careers-lobby__filter') ];
    const filterItems = [ ...wrapper.querySelectorAll('.c-filter-primary__item') ];

    if (filters.length === 0) {
      return;
    }

    filters.forEach(filter => {
      filter.addEventListener('click', thisFilter => {
        const thisFilterNode = thisFilter.currentTarget;

        thisFilterNode.classList.toggle(this.classes.dropdownOpen);
      });
    });

    filterItems.forEach(filterItem => {
      filterItem.addEventListener('click', thisFilterItem => {
        thisFilterItem.stopPropagation();
        const thisFilterItemNode = thisFilterItem.currentTarget;
        const filterItemValue = thisFilterItemNode.dataset.value;
        const filterItemType = thisFilterItemNode.dataset.type;
        const filterItemText = thisFilterItemNode.innerHTML;
        const filterParent = wrapper.querySelector(`.c-filter-primary--${filterItemType}`);
        const filterLabel = filterParent.querySelector('.c-filter-primary__label-text');

        filterLabel.innerHTML = filterItemText;
        filterParent.dataset.selected = filterItemValue;

        filterItems.forEach(item => {
          item.classList.remove(this.classes.active);
        });

        thisFilterItemNode.classList.add(this.classes.active);

        filters.forEach(filter => {
          filter.classList.remove(this.classes.dropdownOpen);
        });

        this.filterJobs(wrapper, filterItemValue, filterItemType, allJobs);
      });
    });
  }

  filterJobs(wrapper, filterItemValue, filterItemType, allJobs) {
    const jobsWrapper = wrapper.querySelector(this.selectors.jobs);
    const jobsPerPage = parseInt(jobsWrapper.dataset.jobsPerPage, 10);
    let newJobs;

    if (filterItemValue !== 'all') {
      newJobs = allJobs.filter(job => job.dataset[filterItemType] === filterItemValue);
    } else {
      newJobs = allJobs;
    }

    // Check if other filter selected
    const otherFilter = wrapper.querySelector(`.c-filter-primary--${filterItemType === 'location' ? 'department' : 'location'}`);
    const otherFilterValue = otherFilter.dataset.selected;

    if (otherFilterValue && otherFilterValue !== 'all') {
      newJobs = newJobs.filter(job => job.dataset[filterItemType === 'location' ? 'department' : 'location'] === otherFilterValue);
    }

    this.renderJobs(wrapper, newJobs, jobsPerPage);
  }

  renderJobs(wrapper, jobs, jobsPerPage) {
    const pagesCount = Math.ceil(jobs.length / jobsPerPage);
    const jobsWrapper = wrapper.querySelector(this.selectors.jobsWrap);
    const pagination = wrapper.querySelector(this.selectors.pagination);
    const paginationPages = wrapper.querySelector(this.selectors.paginationPages);
    const { noJobsText } = jobsWrapper.dataset;

    paginationPages.innerHTML = '';
    jobsWrapper.innerHTML = '';

    if (jobs.length === 0) {
      jobsWrapper.innerHTML = `<div class="b-careers-lobby__jobs-empty">${noJobsText}</div>`;
      pagination.classList.add('hidden');

      return;
    }

    if (pagesCount > 1) {
      pagination.classList.remove('hidden');

      for (let i = 0; i < pagesCount; i++) {
        paginationPages.innerHTML += `<button class="btn b-careers-lobby__jobs-pagination-item ${!i ? 'active' : ''}" data-page="${i}">${i + 1}</button>`;
      }
    } else {
      pagination.classList.add('hidden');
    }

    jobsWrapper.innerHTML += '<div class="b-careers-lobby__jobs-page b-careers-lobby__jobs-page--1 active"></div>';

    jobs.forEach((job, index) => {
      if (index % jobsPerPage === 0 && index !== 0) {
        jobsWrapper.innerHTML += `<div class="b-careers-lobby__jobs-page b-careers-lobby__jobs-page--${Math.ceil((index + 1) / jobsPerPage)}"></div>`;
      }

      jobsWrapper.querySelector(`.b-careers-lobby__jobs-page--${Math.ceil((index + 1) / jobsPerPage)}`).innerHTML += job.outerHTML;
    });
  }

  pagination(wrapper) {
    const prev = wrapper.querySelector(this.selectors.paginationPrev);
    const next = wrapper.querySelector(this.selectors.paginationNext);

    // Events
    prev.addEventListener('click', () => {
      this.changePage(wrapper, 'prev');
    });

    next.addEventListener('click', () => {
      this.changePage(wrapper, 'next');
    });

    wrapper.addEventListener('click', evnt => {
      if (evnt.target && evnt.target.closest && evnt.target.closest(this.selectors.paginationItem)) {
        const target = evnt.target.closest(this.selectors.paginationItem);

        this.changePage(wrapper, parseInt(target.getAttribute('data-page'), 10));
      }
    });
  }

  changePage(wrapper, page) { // eslint-disable-line sonarjs/cognitive-complexity
    const pages = [ ...wrapper.querySelectorAll(this.selectors.page) ];
    const paginationItems = [ ...wrapper.querySelectorAll(this.selectors.paginationItem) ];
    const activePage = pages.find(pg => pg.classList.contains(this.classes.active));
    const activePaginationItem = paginationItems.find(pg => pg.classList.contains(this.classes.active));
    const activePageIndex = pages.indexOf(activePage);
    let newPageIndex;
    const paginationPrev = wrapper.querySelector(this.selectors.paginationPrev);
    const paginationNext = wrapper.querySelector(this.selectors.paginationNext);

    if (page === 'prev') {
      newPageIndex = activePageIndex === 0 ? 0 : activePageIndex - 1;
      paginationNext.classList.remove(this.classes.disabled);
    } else if (page === 'next') {
      newPageIndex = activePageIndex === pages.length - 1 ? pages.length - 1 : activePageIndex + 1;
      paginationPrev.classList.remove(this.classes.disabled);
    } else {
      newPageIndex = page;
    }

    const newPage = pages[newPageIndex];
    const newPaginationItem = paginationItems[newPageIndex];

    if (!newPage) {
      return;
    }

    if (newPageIndex === pages.length - 1) {
      paginationNext.classList.add(this.classes.disabled);
    }

    if (newPageIndex === 0) {
      paginationPrev.classList.add(this.classes.disabled);
    }

    if (newPageIndex > 0) {
      paginationPrev.classList.remove(this.classes.disabled);
    }

    if (newPageIndex < pages.length - 1) {
      paginationNext.classList.remove(this.classes.disabled);
    }

    activePage.classList.remove(this.classes.active);
    newPage.classList.add(this.classes.active);

    activePaginationItem.classList.remove(this.classes.active);
    newPaginationItem.classList.add(this.classes.active);

    paginationItems.forEach(item => {
      if (item === newPaginationItem) {
        item.classList.add(this.classes.active);
      } else {
        item.classList.remove(this.classes.active);
      }
    });

    // Scroll to the top of the list
    const targetElement = document.querySelector(this.selector);

    if (targetElement) {
      const targetOffset = targetElement.offsetTop;
      const offset = targetOffset;

      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      });
    }
  }
}
